import  request  from '../../Interceptor/request.js'

//根据单号查询具体内容
export function numberSel(data) {
    return request({
        url: '/order/list',
        method: 'get',
        params:data
    })
}

